module.exports = __webpack_public_path__ + "img/recieve_otp.6a0a527b.svg";